import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { VehicleCategory } from 'types/products';

interface FiltersProps {
  options: VehicleCategory[] | null;
  selectedValue: string;
  setSelectedFilter: (value: string) => void;
}

export const ProductFilters: React.FC<FiltersProps> = ({
  options,
  selectedValue,
  setSelectedFilter,
}) => {
  const buttonStyle = {
    border: '1px solid #FFFFFF',
    boxShadow: '-3px -3px 28px 0px #0670B1AB inset',
    background: 'linear-gradient(180deg, #EFF9FF 0%, #F2FAFF 100%)',
    color: '#000000',
    borderRadius: '14px',
    padding: '10px 20px',
  };
  return (
    <Box
      sx={{
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        width: '90%',
        margin: 'auto',
        scrollbarWidth: 'none', // Firefox
        '-ms-overflow-style': 'none', // IE 10+
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Opera
        },
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          flexWrap: 'nowrap', // prevent wrapping
          justifyContent: 'space-evenly',
        }}
      >
        <Button
          key={-1}
          style={
            selectedValue === 'all'
              ? { ...buttonStyle, border: '4px solid #FFFFFF' }
              : buttonStyle
          }
          onClick={() => setSelectedFilter('all')}
          sx={{
            textTransform: 'none',
            borderRadius: '20px',
            minWidth: '120px', // use minWidth instead of width % for scrollable layout
            flex: '0 0 auto', // prevent shrinking
          }}
        >
          All
        </Button>
        {options &&
          options.map((option) => (
            <Button
              key={option.Name}
              style={
                selectedValue === option.ID
                  ? { ...buttonStyle, border: '4px solid #FFFFFF' }
                  : buttonStyle
              }
              onClick={() => setSelectedFilter(option.ID)}
              sx={{
                textTransform: 'none',
                borderRadius: '20px',
                minWidth: '120px',
                flex: '0 0 auto',
              }}
            >
              {option.Name}
            </Button>
          ))}
      </Stack>
    </Box>
  );
};
